import axios from "axios";
import { toast } from "react-toastify";

export const clientAxios = axios.create({
   //baseURL: "https://api.olivego.axra.app/admin/",
  baseURL: "https://api.olivego.com/admin/",
});

clientAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem("acstkn");
  config.headers.authorization = `Bearer ${token}`;
  config.headers['Content-Type'] = 'application/json';
  return config;
});

function catchError(err) {
  if (err?.response?.data?.message) {
    const message = err?.response?.data?.message;
    toast.error(message);
    return {
      error: true,
      message: message,
    };
  }
  toast.error(
    err.message ? err.message : "Unexpected error occurred. Try again."
  );
  return {
    error: true,
    message: err.message
      ? err.message
      : "Unexpected error occurred. Try again.",
  };
}

export async function fetchDataFrom(endpoint, headers = {}) {
  try {
    const { data } = await clientAxios.get(endpoint, { headers });
    
    // Handle different API response formats
    if (data.result) {
      // Standard format with result wrapper
      if (data.result.meta) {
        const { total_page } = data.result.meta;
        data.result.meta.pages = total_page;
      }
      return data.result;
    } else if (data.data) {
      // Direct data format (like activity-logs API)
      if (data.meta) {
        const { total_page, last_page } = data.meta;
        // Map both total_page and last_page to pages for compatibility
        data.meta.pages = total_page || last_page;
      }
      return data;
    } else {
      toast.error(data.message || "No data received");
      return { ...data, error: true };
    }
  } catch (err) {
    catchError(err);
  }
}

export async function postDataTo(endpoint, body) {
  try {
    const { data } = await clientAxios.post(endpoint, body);
    // Show success toast if the request was successful
    if (data.result !== undefined) {
      toast.success(data?.message || "Success");
      return data.result;
    } else if (data.data !== undefined) {
      // Handle case where response has data property instead of result
      toast.success(data?.message || "Success");
      return data.data;
    } else {
      // API returned success but no result/data - still show success
      toast.success(data?.message || "Operation completed successfully");
      return data;
    }
  } catch (err) {
    catchError(err);
  }
}

export async function editDataFrom(endpoint, body) {
  try {
    const { data } = await clientAxios.put(endpoint, body);
    if (data.result) {
      toast.success(data.message);
      return data.result;
    } else {
      toast.error(data.message);
      return { ...data, error: true };
    }
  } catch (err) {
    catchError(err);
  }
}

export async function deleteDataFrom(endpoint) {
  try {
    const { data } = await clientAxios.delete(endpoint);
    toast.success(data.message);
  } catch (err) {
    catchError(err);
  }
}

export async function cancelReturnRequest(returnId) {
  try {
    const { data } = await clientAxios.put(`return-orders/${returnId}/cancel`, {}, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    if (data.result) {
      toast.success(data.message || "Return request cancelled successfully");
      return data.result;
    } else if (data.data) {
      toast.success(data.message || "Return request cancelled successfully");
      return data.data;
    } else {
      toast.success(data.message || "Return request cancelled successfully");
      return data;
    }
  } catch (err) {
    catchError(err);
  }
}

export async function updateReturnRequestStatus(returnId, status) {
  try {
    const { data } = await clientAxios.put(`return-orders/${returnId}/update-status`, {
      status: status
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    if (data.result) {
      toast.success(data.message || "Return request status updated successfully");
      return data.result;
    } else if (data.data) {
      toast.success(data.message || "Return request status updated successfully");
      return data.data;
    } else {
      toast.success(data.message || "Return request status updated successfully");
      return data;
    }
  } catch (err) {
    catchError(err);
  }
}
